import { Components } from "@thisgorilla/primate-ds";
import { useContext, useEffect, useState } from "react";
import styled, { useTheme } from "styled-components";
import { CreatePostModalContext } from "../..";
import { API_CALLS } from "../../../../../../../../API/api_calls";
import { FlexColumn, FlexRow } from "../../../../../../../Common/Styles";
import CollaboratorDropdown from "./CollaboratorDropdown";

const Collaborator = () => {
  const { typography, Color } = useTheme();
  const [showModal, setShowModal] = useState(false);
  const [filterText, setFilterText] = useState("n");
  const { selectedCollaborator, setSelectedCollaborator } = useContext(
    CreatePostModalContext
  );

  useEffect(() => {
    API_CALLS.GLOBAL.searchCollaborators({
      query: filterText,
      page: 1,
    }).then(() => {
      const element = document.getElementById("collaborator-list");
      if (element) {
        element.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    });
  }, [filterText]);

  return (
    <FlexColumn>
      <HeaderContainer>
        <Components.Text
          style={{ tokenStyle: typography.Heading.XXS }}
          text="Collaborators"
          fontWeight="font-weight-semibold"
          lineHeight="line-height-50"
        />
        {selectedCollaborator.length === 0 && (
          <RelativeContainer>
            <Components.IconButton
              iconType="Plus"
              onClick={() => {
                setShowModal(true);
              }}
              disabled={false}
              kind="Secondary"
              size="Small"
            />
            {showModal && (
              <CollaboratorDropdown
                setShowModal={setShowModal}
                setFilterText={setFilterText}
                filterText={filterText}
              />
            )}
          </RelativeContainer>
        )}
      </HeaderContainer>
      {selectedCollaborator.length > 0 && (
        <BackgroundImageContainer>
          <Components.Text
            style={{ tokenStyle: typography.Body.S }}
            text="Add collaborators to your post."
            lineHeight="line-height-75"
            fontWeight="font-weight-semibold"
            color={Color.text["text-emphasize-brand-bolder"].value}
          />
          <FlexRow $gapInPx={8}>
            <RelativeContainer>
              <Components.Tooltip type="label" label="Add collaborators">
                <AddImage>
                  <Components.IconButton
                    iconType="Plus"
                    onClick={() => {
                      setShowModal(true);
                    }}
                    disabled={false}
                    kind="Tertiary"
                    size="Small"
                  />
                </AddImage>
              </Components.Tooltip>
              {showModal && (
                <CollaboratorDropdown
                  setShowModal={setShowModal}
                  setFilterText={setFilterText}
                  filterText={filterText}
                />
              )}
            </RelativeContainer>
            <Container>
              {selectedCollaborator.map((user) => (
                <Components.MentionChip
                  key={user.id}
                  profile_picture={user.profile_picture}
                  name={`${user.first_name} ${user.last_name}`}
                  onClose={() => {
                    setSelectedCollaborator((prev) =>
                      prev.filter((c) => c.id !== user.id)
                    );
                  }}
                  showCloseIcon
                />
              ))}
            </Container>
          </FlexRow>
        </BackgroundImageContainer>
      )}
    </FlexColumn>
  );
};

export default Collaborator;

const BackgroundImageContainer = styled(FlexColumn)`
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  background: linear-gradient(
    116deg,
    #f4fbff 21.57%,
    rgba(230, 236, 255, 0) 76.26%
  );
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;

const AddImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: ${({ theme }) => theme.spacing["spacing-12"].value}rem;
  height: ${({ theme }) => theme.spacing["spacing-12"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  background: ${({ theme }) =>
    theme.Color.background.brand.subtlest["default-hover"].value};
  cursor: pointer;
`;

const Container = styled(FlexRow)`
  width: 100%;
  height: 100%;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-overlay"].value};
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  align-items: center;
  flex-wrap: wrap;
  padding: ${({ theme }) => theme.spacing["spacing-1"].value}rem;
`;

const RelativeContainer = styled.div`
  position: relative;
  height: fit-content;
`;
